import { ISbLink } from '../interfaces/common';

export function isSbLinkValid(link: ISbLink): boolean {
	return link.cached_url !== '' || link.url !== '';
}
